export default __webpack_public_path__ + "static/media/cedenar_logo.054f70da.png";